// A webinar poster is stored as a bare filename (e.g. "poster-123-456.jpg")
// returned by POST /webinar/upload-poster. Reads from the API also carry an
// absolute `poster_url` — prefer that, and fall back to building one from the
// uploads base for a value that has just been uploaded in the form and has no
// row behind it yet.
//
// WHY THIS NO LONGER MIRRORS resolveBadgeImage: that helper does
//   (REACT_APP_UPLOADS_URL || '').replace(/\/?uploads\/?$/i, '/uploads/')
// which only rewrites a base that ALREADY ends in "uploads". Ours is set to
// 'http://localhost:4002/', so the regex never matched, the base was used as-is
// and every freshly uploaded poster resolved to
//   http://localhost:4002/poster-123.png   -> 404
// instead of
//   http://localhost:4002/uploads/poster-123.png   -> 200
// which is why the preview showed a broken image in both modals. The base is
// now normalised explicitly rather than by a regex that silently no-ops.
export const resolveWebinarPoster = (value, posterUrl) => {
  // The API's own absolute URL always wins: it is built from the request host
  // and needs no client-side env var to be correct.
  if (posterUrl) return posterUrl;
  if (!value) return '';
  if (/^https?:\/\//i.test(value)) return value;

  const configured = String(process.env.REACT_APP_UPLOADS_URL || '').trim();
  // No base configured and no poster_url to fall back on — return '' rather
  // than a relative path that would resolve against the admin panel's own
  // origin and 404 there.
  if (!configured) return '';

  // Accept the base with or without a trailing slash, and with or without the
  // /uploads segment already on it, so the same value works either way.
  const base = `${configured.replace(/\/+$/, '').replace(/\/uploads$/i, '')}/uploads/`;
  return `${base}${String(value).replace(/^\/?uploads\//i, '')}`;
};
